import React, { useEffect, useState } from 'react';
import supabase from '../../services/supabase';

const categoryMarkerMap = {
  Promoted: '/promotedmarker.webp',
  Entertainment: '/popcornmarker.webp',
  'Hidden Gems': '/gemmarker.webp',
  Flowers: '/flowermarker.webp',
  Stargazing: '/starmarker.webp',
};

const eggheadMarkersByName = {
  'Egghead (Bookhead)': '/bookhead.png',
  'EggHead (Stargazer)': '/stargazing.png',
  'EggHead (Eye on Mrak)': '/mrak.png',
  'EggHead (See No Evil/Hear No Evil)': '/evil.png',
  'EggHead (Yin & Yang)': '/yinyang.png',
};

export default function SimplePlacesList({ limit = 6, onSelect }) {
  const [spots, setSpots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase.from('places').select('id, name, lat, lng, category');
        if (error) throw error;
        const list = Array.isArray(data) ? data.slice() : [];
        // Shuffle
        for (let i = list.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [list[i], list[j]] = [list[j], list[i]];
        }
        const chosen = list.slice(0, limit);
        if (active) setSpots(chosen);
      } catch (e) {
        console.error('SimplePlacesList error:', e);
        if (active) setSpots([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [limit]);

  if (loading) {
    return (
      <div className="leaders-list">
        {Array.from({ length: Math.min(limit, 6) }).map((_, i) => (
          <div key={i} className="leader-row skeleton" />
        ))}
      </div>
    );
  }

  if (!spots.length) {
    return <div className="leaders-empty">No spots yet.</div>;
  }

  return (
    <div className="place-list">
      {spots.map((s) => (
        <button
          key={s.id || s.name}
          className="place-row"
          onClick={() => {
            if (typeof onSelect === 'function') onSelect(s);
          }}
        >
          {(() => {
            let src = '/newmarker.png';
            if (s.category === 'Eggheads') {
              src = eggheadMarkersByName[s.name] || '/bookhead.png';
            } else if (s.category && categoryMarkerMap[s.category]) {
              src = categoryMarkerMap[s.category];
            }
            return <img className="place-icon" src={src} alt={s.category || 'marker'} />;
          })()}
          <span className="leader-name">{s.name || 'Unknown spot'}</span>
          <span className="leader-posts">Open</span>
        </button>
      ))}
    </div>
  );
}


